import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import React, { useRef } from "react";

import type { CustomHeaderGroupProps } from "ag-grid-react";

/**
 * Custom header group component for plan option columns (e.g. "Not Applicable", "Option 1").
 *
 * AG Grid does not render a built-in menu button on column group headers.
 * This component adds a 3-dot button that opens the column menu configured
 * via `mainMenuItems` on the `ColGroupDef`.
 */
const PlanOptionGroupHeader = (
  props: CustomHeaderGroupProps,
): React.JSX.Element => {
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const handleMenuClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    if (menuButtonRef.current) {
      props.showColumnMenu(menuButtonRef.current);
    }
  };

  return (
    <div
      className="ag-header-group-cell-label"
      style={{ width: "100%", display: "flex", alignItems: "center" }}
    >
      <span
        className="ag-header-group-text"
        style={{ flex: 1, textAlign: "center" }}
      >
        {props.displayName}
      </span>
      <IconButton
        ref={menuButtonRef}
        size="small"
        onClick={handleMenuClick}
        aria-label={`Menu for ${props.displayName}`}
        sx={{
          padding: "2px",
        }}
      >
        <MoreVertIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </div>
  );
};

PlanOptionGroupHeader.displayName = "PlanOptionGroupHeader";
export default PlanOptionGroupHeader;
